import React, { useEffect, useState } from 'react';
import AppStrings from '../../config/appstring';
import axios from 'axios';
import AcademicFeesForm from './AcademicFees';
import TransportFeesForm from './TransportFees';
import StatementViewForm from './StatementView';
import FeesPrint from '../Print/FeesPrint';
import AdditionalFeesForm from './AdditionalFees';
import TestHeaderWithSlider from './Test';
import AcademicFeesForm1 from './MutiDTList';
import BonafidePrint from '../BonafideCertificate/BonafidePrint';

function FeesListForm({ onClose, studentData }) {


 
const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
  const closeModal = () => setActiveForm(null);
    const closeForm = () => setActiveForm(null);
     const [activeForm, setActiveForm] = useState(null); 
   const [feeDetails, setFeeDetails] = useState([]);
   

   const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleCancel =  async () => {
   // setSelectedRow(null);
   // setFeeDetails([]);
   setFeeDetails([]);
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);

   const handleSubmit = async () => {
      const payload = {
        student: {
          id: '1007',
           admissionDate: admissionDate,
           type: 'MET',
        },
        fees: feeDetails .filter(({ current, discount }) => {
          const paid = parseFloat(current) || 0;
          const off = parseFloat(discount) || 0;
          return paid + off > 0;
        }).map(({ TYPE, FEES,current, discount }) => ({
          TYPE,
          FEES,
          current,
          discount
        }))
      };
  
      try {
        console.log('haiiii');
        //const res = await fetch("https://school.agnisofterp.com/agni/testing/entry", {
          const res = await fetch(AppStrings.StudentFeesEntry, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
  
        const result = await res.json();
        console.log('haiiii22');
        alert(result.message || "Data saved successfully!");
        handleCancel();
       // fetchStudentData();
        console.log('haiiii33');
      } catch (err) {
        console.error("Error:", err);
        alert("Failed to save data.");
      }
    };


    
      useEffect(() => {
        handlePayClick();
      }, []);

    const handlePayClick = async () => {
   const feeType = studentData.addfees;
    const className = studentData.class;
    const type = 'N';
    const AdmissionID=studentData.id

    if (!feeType || !className) {
      alert('Missing class or fee type for this student.');
      return;
    }

    //const url = `https://school.agnisofterp.com/agni/fees/list?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}`;
    const url = AppStrings.StudentPaymentHistory+`?studentid=${AdmissionID}`;

    try {
      const response = await axios.get(url);
      const result =  response.data.data.SCHOOLPAYMENT;
console.log('lllllll444',result);
      if (Array.isArray(result)) {
        const withEditable = result.map(item => ({ ...item, current: '', discount: '' }));
         //setMode('pay');
       // setSelectedRow(row);
        setFeeDetails(withEditable);
      } else {
       // alert(`No fee records found for ${row.NAME}`);
       // alert(`No fee records found for HIIIII`);
        setFeeDetails([]);
      }
    } catch (error) {
      console.error("Error fetching fee details:", error);
      //alert("Failed to fetch fee details.");
    }
  };


  return (
    <div style={modalOverlayStyle}>
      <div style={{ ...modalStyle, position: 'relative' }}>
        {/* Top-right Close "X" Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'transparent',
            //background: 'red',
            border: 'none',
            fontSize: '30px',
            fontWeight: 'bold',
            cursor: 'pointer',
            color: '#888',
          }}
          aria-label="Close"
        >
          &times;
        </button>

        <h3 style={{ textAlign: 'center' }}>Fees List</h3>

        {studentData && (
          <div style={{ marginBottom: '15px', textAlign: 'center' }}>
            <strong>Student:</strong> {studentData.name}
            <strong>Id:</strong> {studentData.id}
          </div>
        )}

        <div style={buttonGroupStyle}>
          {/* <button onClick={() => setActiveForm('pay')}>Academic Fees</button>
          <button onClick={() => setActiveForm('cancel')}>Transport Fees</button> */}
            <button onClick={() => setActiveForm('Fees')}>Fee Collection</button>
             <button onClick={() => setActiveForm('additional')}>Additional Fee Add</button>
          <button onClick={() => setActiveForm('view')}>Statement View</button>
          {/* <button onClick={() => setActiveForm('receipt')}>Print Receipt</button> */}
          <button onClick={() => setActiveForm('Bonafide')}>Bonafide Receipt</button>
         
        </div>
         
      </div>

      {activeForm && (
        <div style={modalOverlayStyle} onClick={closeModal}>
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            {activeForm === 'pay' && (
              <>
                 
                          <AcademicFeesForm onClose={closeForm} studentData={studentData} />
                      
              </>
            )}
            {activeForm === 'cancel' && (
              <>
                 <TransportFeesForm onClose={closeForm} studentData={studentData} />
              </>
            )}
            {activeForm === 'view' && (
              <>
                <StatementViewForm onClose={closeForm} studentData={studentData} />
              </>
            )}
            {activeForm === 'receipt' && (
              <>
               <FeesPrint onClose={closeForm} RefNo={'2425SCISM2547'} />
              </>
            )}
             {activeForm === 'additional' && (
              <>
                 
                          <AdditionalFeesForm onClose={closeForm} studentData={studentData} />
                      
              </>
            )}
              {activeForm === 'Fees' && (
              <>
               
                          <TestHeaderWithSlider onClose={closeForm} studentData={studentData} />
                      
              </>
            )}
          {activeForm === 'Bonafide' && (
              <>
               
                          <BonafidePrint onClose={closeForm} RefNo={'2425SCISM2432'} />
                      
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default FeesListForm;

// === Styles ===

const headerCellStyle = {
//  border: '1px solid #ddd',
  padding: '8px',
  backgroundColor: '#f2f2f2',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};
const cellStyle = {
  //border: '1px solid #ddd',
padding: '2px',
  fontSize:'13px'
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '600px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
};

const buttonGroupStyle = {
  display: 'flex',
  gap: '10px',
  justifyContent: 'center',
  flexWrap: 'wrap',
  marginTop: '20px',
};
